export const slugifyQueryHandle = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

export const buildHandleMaps = (items, labelResolver) => {
  const idToHandle = {};
  const handleToId = {};

  (items || []).forEach((item) => {
    const itemId = item?.id;
    if (!itemId) return;

    const baseHandle = slugifyQueryHandle(labelResolver(item)) || `item-${String(itemId).slice(0, 6)}`;
    let nextHandle = baseHandle;
    let suffix = 2;

    while (handleToId[nextHandle] && handleToId[nextHandle] !== itemId) {
      nextHandle = `${baseHandle}-${suffix}`;
      suffix += 1;
    }

    idToHandle[itemId] = nextHandle;
    handleToId[nextHandle] = itemId;
  });

  return { idToHandle, handleToId };
};

export const resolveHandleOrLegacyId = ({ cleanValue, legacyValue, handleToId }) => {
  if (cleanValue) {
    return handleToId?.[cleanValue] || legacyValue || null;
  }

  return legacyValue || null;
};

export const applyCleanOrLegacyParam = ({ params, cleanKey, legacyKey, value, idToHandle, keepAll = false }) => {
  if (!value || (!keepAll && value === 'all')) return;

  const handle = idToHandle?.[value];
  if (handle) {
    params.set(cleanKey, handle);
  } else {
    params.set(legacyKey, value);
  }
};